module.exports = __webpack_public_path__ + "media/vvv-dashboard-guide-ko.bef60cec.mp4";